import { NetworkError } from "../store/NetworkError";

/**
 * auth_refresh Cookie のセッションを失効させる (logout)。
 * 成功すれば Set-Cookie: Max-Age=0 で両 Cookie がブラウザから消える。
 */
export async function revokeUserToken(): Promise<void> {
    try {
        await fetch("/user-tokens", {
            method: "DELETE",
            credentials: "include",
        });
    } catch (e) {
        throw new NetworkError(e instanceof Error ? e.message : "Network error");
    }
}
